import { createSelector } from "reselect";
import _ from "lodash";
import moment from "moment";
export const selectAllQualifications = ({
    QualificationsManagerV2_reducer
}) => {
    return QualificationsManagerV2_reducer.allQualifications;
};

export const selectQualificationCategories = ({
    QualificationsManagerV2_reducer
}) => {
    return QualificationsManagerV2_reducer.qualificationCategories;
};
export const selectCurrentTable = ({ QualificationsManagerV2_reducer }) => {
    return QualificationsManagerV2_reducer.currentTable;
};
export const getRequesting = ({ QualificationsManagerV2_reducer }) => {
    return QualificationsManagerV2_reducer.requesting;
};
export const selectPageIndex = ({ QualificationsManagerV2_reducer }) => {
    return QualificationsManagerV2_reducer.pageIndex;
};
export const selectRowCount = ({ QualificationsManagerV2_reducer }) => {
    return QualificationsManagerV2_reducer.rowCount;
};
export const selectCategory = ({ QualificationsManagerV2_reducer }) => {
    return QualificationsManagerV2_reducer.category;
};
export const selectUsers = ({ QualificationsManagerV2_reducer }) => {
    return QualificationsManagerV2_reducer.users;
};
export const selectPostSuccess = ({ QualificationsManagerV2_reducer }) => {
    return QualificationsManagerV2_reducer.postSuccess;
};
export const selectPostFail = ({ QualificationsManagerV2_reducer }) => {
    return QualificationsManagerV2_reducer.postFail;
};
export const selectCustomQualifications = ({
    QualificationsManagerV2_reducer
}) => {
    return QualificationsManagerV2_reducer.customQualifications;
};
export const selectViewValidUsersModalInfo = ({
    QualificationsManagerV2_reducer
}) => {
    return QualificationsManagerV2_reducer.viewValidUsersModalInfo;
};
export const selectConfig = ({ MainReducer }) => {
    if (MainReducer.config) return MainReducer.config;
    else return false;
};
export const selectProfile = ({ UserProfile_reducer }) => {
    if (UserProfile_reducer.profile) return UserProfile_reducer.profile.profile;
    else return false;
};
export const selectAllAreas = ({ QualificationsManagerV2_reducer }) => {
    return QualificationsManagerV2_reducer.areas;
};
export const selectAllDepartments = ({ QualificationsManagerV2_reducer }) => {
    return QualificationsManagerV2_reducer.departments;
};
export const selectDept = createSelector(
    [ selectProfile],
    (profile = false) => {
        if(profile){
            return profile.departments
        }else return null
    }
);
export const selectAreas = createSelector(
    [ selectProfile],
    (profile = false) => {
        if(profile){
            return profile.areas
        }else return null
    }
);
export const selectPermissions = createSelector(
    [selectConfig, selectProfile],
    (config = false, { access_level = false }) => {
        if (access_level && config) {
            return config[access_level]["qualifications_manager"];
        } else return false;
    }
);
export const canRead = createSelector([selectPermissions], (config = false) => {
    return config ? config.read : true;
});
export const canUpdate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.update : true;
    }
);
export const canCreate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.create : true;
    }
);
export const canDelete = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.delete : true;
    }
);
export const selectNumberOfCustomQualifications = createSelector(
    [selectCustomQualifications],
    (customQualifications = false) => {
        if (customQualifications) {
            return Object.keys(customQualifications).map(uid => uid).length;
        } else {
            return 0;
        }
    }
);
export const selectNewQualificationIdAndCustomQualificationPrefix = createSelector(
    [selectAllQualifications, selectCustomQualifications],
    (allQualifications = false, customQualifications = false) => {
        if (allQualifications) {
            let latestQualificationID = Object.keys(allQualifications)
                .map(qualification_id => qualification_id)
                .sort()
                .reverse()[0];
            let newQualificationID = (Number(latestQualificationID) + 1)
                .toString()
                .padStart(6, "0");
            let newCustomQualificationPrefix = "CQ 001";
            if (customQualifications) {
                let latestCustomQualificationTitle = Object.keys(
                    customQualifications
                )
                    .map(
                        custom_qualification_id =>
                            customQualifications[custom_qualification_id]
                                .qualification_title
                    )
                    .sort()
                    .reverse()[0]
                    .split(" ")[1];

                newCustomQualificationPrefix =
                    "CQ " +
                    (Number(latestCustomQualificationTitle) + 1)
                        .toString()
                        .padStart(3, "0");
            }
            return {
                id: newQualificationID,
                prefix: newCustomQualificationPrefix
            };
        } else {
            return false;
        }
    }
);
export const selectFilteredQualifications = createSelector(
    [
        selectAllQualifications,
        selectQualificationCategories,
        selectCurrentTable,
        selectCategory
    ],
    (
        allQualifications = false,
        categories = false,
        currentTable = "required",
        category = "all_categories"
    ) => {
        if (allQualifications && categories) {
            let filteredQualifications = [];
            if (currentTable === "required") {
                filteredQualifications = filterQualificationsForTable(
                    allQualifications,
                    true
                );
            } else if (currentTable === "available") {
                filteredQualifications = filterQualificationsForTable(
                    allQualifications,
                    false
                );
            }
            if (category === "all_categories") {
                return _.orderBy(
                    filteredQualifications,
                    "qualification_category"
                );
            } else {
                return filteredQualifications.filter(
                    qualification =>
                        qualification.qualification_category === category
                );
            }
        } else {
            return false;
        }
    }
);

//get users belonging to logged in user areas & depts   
export const selectUserInfoForViewQualificationModal = createSelector(
    [selectViewValidUsersModalInfo, selectUsers, selectAllDepartments, selectAllAreas, selectAreas, selectDept,selectProfile],
    (modalInfo, users = false, allDept = false , allAr = false , userAreas = false, userDepts = false, profile) => {
        
        let allAreas = allAr && Object.values(allAr).map((e)=> { return e })
        let allDepartments = allDept && Object.values(allDept).map((e)=> { return e })
        if(userAreas === false){
            userAreas = allAreas
        }
        if(userDepts === false){
            userDepts = allDepartments
        }
        let validationArea = []
        let validationDept = []
        let totalUsers = _.compact(
            Object.keys(users).map(e => {
                let refArray = []
                let deleted =
                    _.get(users[e], "profile.deleted") || false;
                let areas = 
                    _.get(users[e], "profile.areas") || null
                let departments = 
                    _.get(users[e], "profile.departments") || null 

                if(areas === null ){
                    validationArea = _.intersection(allAreas,userAreas)
                }else{
                    validationArea = _.intersection(areas,userAreas)
                }

                if(departments === null){
                    validationDept = _.intersection(allDepartments,userDepts)
                }else {
                    validationDept = _.intersection(departments,userDepts)
                } 
                
                if (!deleted && validationArea.length !== 0 && validationDept.length !== 0) {
                    refArray.push( users[e] )
                    return users[e];
                        
                } else return null;
            })
        );

        //show details only for admin users
        let accessLevel = '';
        if(profile){
            accessLevel = profile.access_level;
        }
        var accessLevels = ['Level 1', 'Level 2', 'Level 3', 'Level 4', 'Client', 'Contractor']
        if(accessLevels.includes(accessLevel)){
            let user = '';
            Object.keys(users).map(e => {
                let uid = _.get(users[e], "profile.uid") || false;
                if(profile.uid === uid){
                    user = users[e];
                }
                return null;
            });
            totalUsers = [];
            totalUsers.push(user)
        }

        if (totalUsers && modalInfo.qualification_id) {
            let validUserUids = getValidUserUids(totalUsers);
            let tableInfo = validUserUids.map(uid => {
                let qualification =
                    _.get(
                        totalUsers[uid],
                        `profile.qualifications_per_user.${modalInfo.qualification_id}`
                    ) || false;

                let fname = _.get(totalUsers[uid], "profile.first_name") || "N/A";
                let lname = _.get(totalUsers[uid], "profile.last_name") || "N/A";
                if (qualification) {
                    if (isValidQualification(qualification)) {
                        return {
                            user_name: `${fname} ${lname}`,
                            expiry_date: qualification.qualification_exp_date,
                            valid: true,
                            qualification_img:
                                qualification.qualification_valid_img
                        };
                    } else {
                        return {
                            user_name: `${fname} ${lname}`,
                            expiry_date: false,
                            valid: false,
                            qualification_img:
                                qualification.qualification_invalid_img
                        };
                    }
                } else {
                    return {
                        user_name: `${fname} ${lname}`,
                        expiry_date: false,
                        valid: false,
                        qualification_img: false
                    };
                }
            });
            return _.orderBy(
                tableInfo,
                ["valid", "user_name"],
                ["desc", "asc"]
            );
        } else return false;
    }
);

export const selectValidUsersPerQualification = createSelector(
    [selectUsers, selectAllQualifications,],
    (users = false, qualifications = false) => {
        if (qualifications && users) {
            let totalRequiredQualifications = getRequiredQualifications(
                qualifications
            );
            let validUserUids = getValidUserUids(users);

            let validUsersPerQualification = totalRequiredQualifications.map(
                qualification_id => {
                    let completed = 0;
                    validUserUids.map(uid => {
                        let userQualification =
                            _.get(
                                users[uid],
                                `profile.qualifications_per_user.${qualification_id}`
                            ) || false;
                        if (
                            userQualification &&
                            isValidQualification(userQualification)
                        ) {
                            completed++;
                        }
                        return true;
                    });
                    return { qualification_id, completed };
                }
            );
            return validUsersPerQualification;
        } else return false;
    }
);
export const selectTotalValidUsers = createSelector(
    [selectUsers],
    (users = false) => {
        if (users) {
            return getValidUserUids(users).length;
        } else {
            return false;
        }
    }
);

//select users belonging to logged in user areas & deptarments
export const selectInfoForQualificationOverview = createSelector(
    [selectUsers, selectQualificationCategories, selectAllQualifications,selectAllDepartments, selectAllAreas, selectAreas, selectDept,selectProfile],
    (users = false, categories = false, qualifications = false, allDept = false , allAr = false , userAreas = false, userDepts = false,profile) => {

        let allAreas = allAr && Object.values(allAr).map((e)=> { return e })
        let allDepartments = allDept && Object.values(allDept).map((e)=> { return e })
        if(userAreas === false){
            userAreas = allAreas
        }
        if(userDepts === false){
            userDepts = allDepartments
        }
        let validationArea = []
        let validationDept = []
        let totalUsers = _.compact(
            Object.keys(users).map(e => {
                let refArray = []
                let deleted =
                    _.get(users[e], "profile.deleted") || false;
                let areas = 
                    _.get(users[e], "profile.areas") || null
                let departments = 
                    _.get(users[e], "profile.departments") || null 

                if(areas === null ){
                    validationArea = _.intersection(allAreas,userAreas)
                }else{
                    validationArea = _.intersection(areas,userAreas)
                }

                if(departments === null){
                    validationDept = _.intersection(allDepartments,userDepts)
                }else {
                    validationDept = _.intersection(departments,userDepts)
                } 
                
                if (!deleted && validationArea.length !== 0 && validationDept.length !== 0) {
                    refArray.push( users[e] )
                    return users[e];
                        
                } else return null;
            })
        );

        //show details only for admin users
        let accessLevel = '';
        if(profile){
            accessLevel = profile.access_level;
        }
        var accessLevels = ['Level 1', 'Level 2', 'Level 3', 'Level 4', 'Client', 'Contractor']
        if(accessLevels.includes(accessLevel)){
            let user = '';
            Object.keys(users).map(e => {
                let uid = _.get(users[e], "profile.uid") || false;
                if(profile.uid === uid){
                    user = users[e];
                }
                return null;
            });
            totalUsers = [];
            totalUsers.push(user)
        }

        if (totalUsers && categories && qualifications) {
            let requiredQualifications = getRequiredQualifications(
                qualifications
            );

            let qualificationsPerCategory = _.compact(
                Object.keys(categories).map(category_key => {
                    return getRequiredQualificationsInCategory(
                        qualifications,
                        requiredQualifications,
                        categories[category_key]
                    );
                })
            );
            //get chart data, get modal data
            let validUserUids = getValidUserUids(totalUsers);
            let overViewData = qualificationsPerCategory.map(categoryInfo => {
                let chartData = getChartData(
                    validUserUids,
                    totalUsers,
                    categoryInfo
                );
                let modalInfo = _.orderBy(
                    getModalinfo(validUserUids, totalUsers, categoryInfo),
                    ["totalCompleted", "user_name"],
                    ["desc", "asc"]
                );
                return {
                    category_name: categoryInfo.category,
                    chartData,
                    modalInfo
                };
            });
            return overViewData;
        } else return false;
    }
);
const getModalinfo = (validUserUids, totalUsers, categoryInfo) => {
    return validUserUids.map(uid => {
        let fname = _.get(totalUsers[uid], "profile.first_name") || "N/A";
        let lname = _.get(totalUsers[uid], "profile.last_name") || "N/A";
        let totalCompleted = 0;
        let qualificationInfoPerUser = categoryInfo.qualificationsInCategory.map(
            qualification => {
                let userQualification =
                    _.get(
                        totalUsers[uid],
                        `profile.qualifications_per_user.${qualification.qualification_id}`
                    ) || false;
                if (userQualification) {
                    if (isValidQualification(userQualification)) {
                        totalCompleted++;
                        return {
                            qualification_img:
                                userQualification.qualification_valid_img,
                            expiry_date:
                                userQualification.qualification_exp_date
                        };
                    } else {
                        return {
                            qualification_img:
                                userQualification.qualification_invalid_img,
                            expiry_date:
                                userQualification.qualification_exp_date
                        };
                    }
                } else
                    return {
                        qualification_img: false,
                        expiry_date: false
                    };
            }
        );
        return {
            user_name: `${fname} ${lname}`,
            totalCompleted,
            qualificationInfoPerUser
        };
    });
};
const getChartData = (validUserUids, totalUsers, categoryInfo) => {
    return categoryInfo.qualificationsInCategory.map(qualification => {
        let totalCompleted = 0;
        validUserUids.map(uid => {
            let userQualification =
                _.get(
                    totalUsers[uid],
                    `profile.qualifications_per_user.${qualification.qualification_id}`
                ) || false;
            if (userQualification && isValidQualification(userQualification)) {
                totalCompleted++;
            }
            return true;
        });
        return {
            qualification: qualification.qualification_title,
            qualification_img: qualification.qualification_valid_img,
            totalCompleted
        };
    });
};
const getRequiredQualificationsInCategory = (
    allQualifications,
    requiredQualificationIds,
    category
) => {
    let qualificationsInCategory = _.compact(
        requiredQualificationIds.map(qualification_id => {
            if (
                allQualifications[qualification_id].qualification_category ===
                category
            ) {
                return allQualifications[qualification_id];
            } else return null;
        })
    );
    if (qualificationsInCategory.length !== 0) {
        return {
            qualificationsInCategory,
            category: category
        };
    } else return null;
};
const getRequiredQualifications = qualifications => {
    return Object.keys(qualifications).filter(qualification_id => {
        return qualifications[qualification_id].qualification_selected === true;
    });
};
const filterQualificationsForTable = (qualifications, table = true) => {
    return Object.values(qualifications).filter(qualification => {
        return qualification.qualification_selected === table;
    });
};
const getValidUserUids = users => {
    return _.compact(
        Object.keys(users).map(uid => {
            let deleted = _.get(users[uid], "profile.deleted") || false;
            let type = _.get(users[(uid, "profile.type")]) || "person";
            if (!deleted && type === "person") {
                return uid;
            } else return null;
        })
    );
};

const isValidQualification = qualification => {
    let currentDate = moment().startOf("day");
    let inDate =
        qualification.qualification_exp_date === ("" || "Req.")
            ? false
            : moment(
                  qualification.qualification_exp_date,
                  "DD-MM-YYYY"
              ).isAfter(currentDate);
    let verified = qualification.verified === "No" ? false : true;
    if (verified && inDate) {
        return true;
    } else {
        return false;
    }
};
